












import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api'
import { ciTierBadge } from '~/icons/source/solid/tier-badge'
import { SubscriptionTier } from '~/models/search/subscriptions/types'

export default defineComponent({
  props: {
    tier: {
      type: String,
      default: SubscriptionTier.BASIC
    }
  },
  setup(props) {
    const { tier } = toRefs(props)

    const badgeColor = computed(() => {
      if (tier.value === SubscriptionTier.BASIC) {
        return ['tw-text-promote-super']
      } else if (tier.value === SubscriptionTier.PRO) {
        return ['tw-text-promote-turbo']
      }
      return null
    })
    return { badgeColor, ciTierBadge }
  }
})
